import React from "react";
import { Box, Container, Typography, Stack, useMediaQuery, useTheme } from "@mui/material";

// Desktop Assets
import ae955D335 from "../../assets/home/0ae955d335.png";
// import e9B74F7B98 from "../../assets/home/e9b74f7b98.png";
import galaxyTabS8Ultra from "../../assets/home/Galaxy Tab S8 Ultra.png";
import Group_7 from "../../assets/home/Group 7.svg";
import screenshotIphone15ProMax from "../../assets/home/Screenshot-iPhone15 Pro Max.png";
import subtract from "../../assets/home/Subtract.png";

// Mobile Assets
 import moipay from "../../assets/logo/logo 2.svg";
 import staffle from "../../assets/logo/staffle.png";
import pos from "../../assets/mobile/pos.png";
import pro1 from "../../assets/mobile/pro11.svg";
import pro2 from "../../assets/mobile/proo10.svg";
import shade from "../../assets/mobile/Subtract.svg";

// ---------------- Card Components ----------------
const MobileCard1 = () => (
  <Box sx={{ display: "row", gap: 9, px: 2,justifyItems:"center" }}>
    <Box sx={{ position: "relative", width: 150, height: 150,alignItems:"center" }}>
      <Box component="img" src={shade} alt="Shade" sx={{ width: "110%", height: "110%" }} />
      <Box component="img" src={staffle} alt="Logo" sx={{ position: "absolute", top: "-24%", left: "33%", width:63}} />
      <Box component="img" src={pro2} alt="Product" sx={{ position: "absolute", bottom: "16%", left: "32%",width:80  }} />
    </Box>
    <Box sx={{ row: 1, backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2, p: 2, backdropFilter: "blur(3px)",mt:4 }}>
      <Typography sx={{ color: "#fff", fontSize: 15 }}>
        Staflle is our in-house developed Employee Management System designed to streamline and elevate the way we manage our workforce. Built to suit the evolving needs of modern tech companies, this system centralizes employee data, automates HR tasks, across teams.
      </Typography>
    </Box>
  </Box>
);

const MobileCard2 = () => (
  <Box sx={{ display: "row", gap: 9, px: 2,justifyItems:"center" }}>
    <Box sx={{ position: "relative", width: 150, height: 150,alignItems:"center" }}>
      <Box component="img" src={shade} alt="Shade" sx={{ width: "110%", height: "110%" }} />
      <Box component="img" src={moipay} alt="Logo" sx={{ position: "absolute", top: "-24%", left: "33%", width:62}} />
      <Box component="img" src={pro1} alt="Product" sx={{ position: "absolute", bottom: "15%", left: "40%" ,width:45}} />
    </Box>
    <Box sx={{ row: 1, backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2, p: 2, backdropFilter: "blur(3px)",mt:4 }}>
      <Typography sx={{ color: "#fff", fontSize: 16 ,textAlign:"left"}}>
        A user-first fintech app with wallet,bank linking,bill payments,money transfers,GovPay,insurance payments,micro loans,and group expense splitting.
      </Typography>
    </Box>
  </Box>
);

const MobileCard3 = () => (
  <Box sx={{ display: "row", gap: 9, px: 2,justifyItems:"center" }}>
    <Box sx={{ position: "relative", width: 150, height: 150 }}>
      <Box component="img" src={shade} alt="Shade" sx={{ width: "110%", height: "110%" }} />
      <Box component="img" src={pos} alt="Logo" sx={{ position: "absolute", top: "-24%", left: "27%", width: 95 }} />
      <Box component="img" src={pro2} alt="Product" sx={{ position: "absolute", bottom: "15%", left: "35%",width:80 }} />
    </Box>
    <Box sx={{ row: 1, backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2, p: 2, backdropFilter: "blur(3px)",mt:4 }}>
      <Typography sx={{ color: "#fff", fontSize: 15 }}>
        Our advanced Point-of-Sale (POS) system is designed to meet the needs of all types of businesses from small retail shops and supermarkets to restaurants and service centers.
      </Typography>
    </Box>
  </Box>
);

// ---------------- Desktop Card Components ----------------
const DesktopCard1 = () => (
  <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
    <Box sx={{ position: "relative", width: 400, height: 300 }}>
      <Box component="img" src={subtract} alt="Background" sx={{ width: "90%", height: "100%" }} />
      <Box component="img" src={ae955D335} alt="Logo" sx={{ position: "absolute", top: "-24%", left: "29%", width: 150 }} />
      <Box component="img" src={galaxyTabS8Ultra} alt="Product" sx={{ position: "absolute", bottom: "30%", left: "29%", width: 150 }} />
    </Box>
    <Box sx={{ flex: 1, backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 3, p: 3, backdropFilter: "blur(4px)" }}>
      <Typography sx={{ color: "#fff", fontSize: 24 }}><b><i>Staflle</i></b> is our in-house developed Employee Management System designed to streamline and elevate the way we manage our workforce.</Typography>
    </Box>
  </Box>
);

const DesktopCard2 = () => (
  <Box sx={{ display: "flex", flexDirection: "row-reverse", gap: 4, alignItems: "center" }}>
    <Box sx={{ position: "relative", width: 400, height: 300 }}>
      <Box component="img" src={subtract} alt="Background" sx={{ width: "90%", height: "100%" }} />
      <Box component="img" src={moipay} alt="Logo" sx={{ position: "absolute", top: "-24%", left: "29%", width: 120 }} />
      <Box component="img" src={screenshotIphone15ProMax} alt="Product" sx={{ position: "absolute", bottom: "10%", left: "33%", width: 100 }} />
    </Box>
    <Box sx={{ flex: 1, backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 3, p: 3, backdropFilter: "blur(4px)" }}>
      <Typography sx={{ color: "#fff", fontSize: 24 }}>
      A <b><i>Moipay</i></b> is a user-first fintech app with wallet, bank linking, bill payments,QR payments, money transfers, Tax Calculator and insurance payment.
      </Typography>
    </Box>
  </Box>
);

const DesktopCard3 = () => (
  <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
    <Box sx={{ position: "relative", width: 400, height: 300 }}>
      <Box component="img" src={subtract} alt="Background" sx={{ width: "90%", height: "100%" }} />
      <Box component="img" src={Group_7} alt="Logo" sx={{ position: "absolute", top: "-24%", left: "25%", width: 180 }} />
      <Box component="img" src={screenshotIphone15ProMax} alt="Product" sx={{ position: "absolute", bottom: "10%", left: "33%", width: 100 }} />
    </Box>
    <Box sx={{ flex: 1, backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 3, p: 3, backdropFilter: "blur(4px)" }}>
      <Typography sx={{ color: "#fff", fontSize: 24 }}>
       Our advanced <b><i>Point-of-Sale (POS) system </i></b>is designed to meet the needs of all types of businesses from small retail shops and supermarkets to restaurants and service centers.
      </Typography>
    </Box>
  </Box>
);

// ---------------- Main Feature Section ----------------
export default function FeatureSectionPage({
  subtitle = "Fintech Innovation at Your Fingertips",
  titlePart1 = "Seamless websites and mobile apps designed to",
  titlePart2 = "simplify finance for a digital-first future.",
}) {



  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return isMobile ? (
    <Box sx={{ width: "100%", py: 4, background: "#000" }}>
      <Stack spacing={2} alignItems="center" mb={3}>
        <Typography sx={{  fontSize: 15,fontweight: 400,lineheight: "22px",  color: "rgba(255,255,255,0.65)" }}>
          {subtitle}
        </Typography>
        <Typography sx={{  fontSize: 18, color: "#fff", textAlign: "center" }}>
          {titlePart1}
        </Typography>
        <Typography sx={{  fontSize: 16, fontweight: 400,WebkitTextStroke: "0.8px #fff", textAlign: "center" }}>
          {titlePart2}
        </Typography>
      </Stack>
      <Stack spacing={7}>
        <br></br>
        <MobileCard1 />
        <MobileCard2 />
        <MobileCard3 />
      </Stack>
    </Box>
  ) : (
    <Container maxWidth="xl" sx={{ py: 6, background: "#000" }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography sx={{   
  fontSize: 32,lineheight: "32px", fontWeight: 400, color: "#9a9696ff", letterspacing: "2px"
  }}>{subtitle}</Typography>
        <Typography sx={{ fontSize: 32,lineheight: "32px", fontWeight: 700, color: "#fff", letterspacing: "2px"
         }}>{titlePart1}</Typography>
        <Typography sx={{ fontSize: 32, lineheight: "32px",fontWeight: 800, color: "transparent", WebkitTextStroke: "1px #fff",letterspacing: "15px" }}>{titlePart2}</Typography>
      </Box>
      <Stack spacing={4}>
        <br></br>
        <DesktopCard1 />
        <DesktopCard2 />
        <DesktopCard3 />
      </Stack>
    </Container>
  );
}
